var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hastag_1_",
    "data-name": "hastag (1)",
    d: "M27.314,4.686A15.979,15.979,0,0,0,16.024,0H16A16.242,16.242,0,0,0,4.018,5.4a16.018,16.018,0,0,0-1.9,18.566L.941,28.655a1.983,1.983,0,0,0,.494,1.861,1.908,1.908,0,0,0,1.894.541l5.008-1A16.024,16.024,0,0,0,26.6,27.983C30.546,24.147,32,20.274,32,16A15.9,15.9,0,0,0,27.314,4.686Zm-4.081,9.53h-2.44L19.818,17.7h2.29a.938.938,0,0,1,0,1.875H19.293l-.94,3.357a.937.937,0,0,1-1.806-.5l.8-2.853H12.421l-.943,3.369a.964.964,0,0,1-1.156.65.937.937,0,0,1-.65-1.155l.8-2.864H8.715a.938.938,0,0,1,0-1.875H11l.975-3.482H9.84a.938.938,0,0,1,0-1.875H12.5l.924-3.3a.937.937,0,0,1,1.806.505l-.782,2.793H19.37L20.3,9.032a.937.937,0,0,1,1.806.505l-.786,2.8h1.916a.938.938,0,0,1,0,1.875ZM12.946,17.7H17.87l.975-3.482H13.92Zm0,0",
    transform: "translate(0)",
    fill: "#4397d2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyImg3);
export default __webpack_public_path__ + "static/media/whyImg3.026b7592b07cae366c72f0e6c152f28a.svg";
export { ForwardRef as ReactComponent };